import React from "react";
import { Modal } from "react-bootstrap";
import Successicon from "../../assets/Successicon";

const PaymentSuccessModal = (props) => {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="py-3 pb-5">
        <Modal.Body>
          <div className="flex justify-center items-center w-full">
            {/* <img
              src="/assets/paymentSuccess.gif"
              className="h-40 flex items-center justify-center"
            /> */}
            <Successicon />
          </div>

          <h4 className="text-center mt-4">Payment Successful!</h4>
          <p className="text-center mt-2">
            Thankyou for your payment. Your transaction has been completed
            successfully.
          </p>
        </Modal.Body>

        <div className="flex items-center justify-center">
          <button
            onClick={props.onHide}
            className="bg-green-600 py-[6px] px-4 text-white text-base font-medium"
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentSuccessModal;
